import "../../Projects/Maison_Marline/Maison_Marline.css";
import Hero from "../../Projects/Maison_Marline/Hero.jsx";
import AboutUs from "../../Projects/Maison_Marline/AboutUs.jsx";
import Banner from "../../Projects/Maison_Marline/Banner.jsx";
import Palette from "../../Projects/Maison_Marline/Palette.jsx";
import Logo from "../../Projects/Maison_Marline/Logo.jsx";
import Footer from "../../general/Footer.jsx";

export default function MaisonMarlinePage() {
  return (
    <div className="maison_marline-page">
      <Hero />
      <AboutUs />
      <Banner />
      <Palette />
      <Logo />
      <Footer />
    </div>
  );
}
